import Api from "@/services/api";
import {downloadData} from "@utils";

export default {
  download() {
    return Api().get("/doc/download/faq/", {responseType: "blob"}).then(res => downloadData(res));
  },
}